import { useEffect, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { signInWithRedirect } from 'aws-amplify/auth';
import AuthLoadingSpinner from './AuthLoadingSpinner';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { t } = useTranslation('auth');
  const { authStatus } = useAuthenticator();
  const navigate = useNavigate();

  useEffect(() => {
    if (authStatus === 'unauthenticated') {
      // Check if user intentionally logged out
      const intentionalLogout = sessionStorage.getItem('intentionalLogout');
      if (intentionalLogout === 'true') {
        // Clear the flag and redirect to logged out page
        sessionStorage.removeItem('intentionalLogout');
        navigate('/logged-out');
      } else {
        // Auto-redirect to SSO
        signInWithRedirect({ provider: { custom: 'AzureAD' } });
      }
    }
  }, [authStatus, navigate]);

  if (authStatus === 'configuring') {
    return <AuthLoadingSpinner message={t('checkingAuth')} />;
  }

  if (authStatus === 'unauthenticated') {
    return <AuthLoadingSpinner message={t('redirectingToLogin')} />;
  }

  return <>{children}</>;
}
